import script from "./EditParam.vue?vue&type=script&setup=true&lang=js"
export * from "./EditParam.vue?vue&type=script&setup=true&lang=js"

import "./EditParam.vue?vue&type=style&index=0&id=205f4065&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205f4065"]])

export default __exports__